import { render, staticRenderFns } from "./EntityViews.vue?vue&type=template&id=55f57bb4&scoped=true"
import script from "./EntityViews.vue?vue&type=script&lang=js"
export * from "./EntityViews.vue?vue&type=script&lang=js"
import style0 from "./EntityViews.vue?vue&type=style&index=0&id=55f57bb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f57bb4",
  null
  
)

export default component.exports